import script from "./DataWarga.vue?vue&type=script&setup=true&lang=js"
export * from "./DataWarga.vue?vue&type=script&setup=true&lang=js"

import "./DataWarga.vue?vue&type=style&index=0&id=3da120d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da120d1"]])

export default __exports__